import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-icons',
    templateUrl: './icons.component.html',
    styleUrl: './icons.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IconsComponent {

  @Input() icon:string = ''
}
